import styled from 'styled-components';
import { Button } from '~/components';
import { Icon, Typography, getTheme, pxToRem } from '~/modules';

const backgroundZ2 = getTheme('background.z2');
const borderRadius = getTheme('themeRadius.card');
const mdSpacing = getTheme('spacing.md');
const smSpacing = getTheme('spacing.sm');
const textLink = getTheme('text.link');

export const BenefitsSection = styled.div`
  display: flex;
  gap: ${mdSpacing}px;
`;

export const BenefitCard = styled.div`
  background-color: ${backgroundZ2};
  padding: ${mdSpacing}px;
  border-radius: ${borderRadius}px;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  gap: ${smSpacing}px;
`;

export const BenefitCardIcon = styled(Icon).attrs({
  fontSize: pxToRem(24),
})`
  color: ${textLink};
`;

export const BenefitCardTitle = styled(Typography).attrs({
  variant: 'sm',
})`
  font-weight: 600;
  color: ${textLink};
  line-height: 1.3;
`;

export const BenefitCardDescription = styled(Typography).attrs({
  variant: 'xs',
})`
  font-weight: 400;
  opacity: 0.7;
  line-height: 1.5;
`;

export const ButtonComponent = styled(Button)`
  width: 100%;
  margin: auto;
`;
